import React, { useEffect, useRef } from 'react'
import { CrownOutlined, LockOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { truncateText } from '../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { PlusIcon } from '../../utils/icons';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import CreateNewChannelModal from '../Channel/CreateNewChannelModal';
import { setMessageDetailsReducer } from '../../slices/userSlice';

const ChannelInChannelList = ({ channel, onClick }) => {
  const dispatch = useDispatch();
  const userChannelList = useSelector((state) => state.user.userChannelList) || [];
  const newMsgDetailObj = useSelector((state) => state.user.newMsgDetailObj) || {};
  const selectedChannel = useSelector((state) => state.user.selectedUserOrChannel) || {};
  const newMsgDetailObjRef = useRef(newMsgDetailObj);

  useEffect(() => {
    newMsgDetailObjRef.current = newMsgDetailObj;
  }, [newMsgDetailObj]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      // console.log(selectedUser?.PK?.S, " === ", newMsgDetailObjRef.current[selectedUser?.PK?.S], "setInterval", newMsgDetailObjRef.current);
      if (selectedChannel?.SK && newMsgDetailObjRef.current[selectedChannel?.SK]) {
        dispatch(setMessageDetailsReducer({ userId: selectedChannel?.SK, isRemove: true }));
        console.log("set timeout");
      } 
    }, 30000);

    return () => clearInterval(intervalId);
  }, [selectedChannel?.SK, dispatch]);

  return (
    <div className={`flex items-center justify-between cursor-pointer p-2 border-b-[1px] shadow-inner rounded-lg mb-2 border-gray-300 ${selectedChannel?.SK === channel?.SK ? "bg-gradient-to-tr from-orange1 to-redOrange text-pureWhite": ""}`} onClick={onClick}>
      <span className="ml-3 mr-2">
          <span className={`text-gray-500 mr-3 ${selectedChannel?.SK === channel?.SK ? "text-pureWhite": ""}`}>
            {channel?.channelDetails?.SK === "Private#" ? 
              <CustomTooltip title="Private">
                <LockOutlined />
              </CustomTooltip>:
              <CustomTooltip title="Public">#</CustomTooltip>}
          </span>
          <CustomTooltip title={channel?.channelDetails?.ChannelName}>
            {truncateText(channel?.channelDetails?.ChannelName, 15)}
          </CustomTooltip>
      </span>
      <div className="flex items-center gap-2">
          {newMsgDetailObj[channel?.SK] > 0 &&
            <div className="rounded-full w-[20px] h-[20px] text-[10px] text-pureWhite bg-orange-600 flex justify-center items-center">
                {newMsgDetailObj[channel?.SK]}
            </div>
          }
          {/* <span className="">
            {channel?.channelDetails?.SK === "Private#" ? (
                <CustomTooltip title="Private">
                <LockOutlined />
                </CustomTooltip>
            ) : (
                <CustomTooltip title="Public">
                <CrownOutlined />
                </CustomTooltip>
            )}
          </span> */}
      </div>
    </div>
  );
}

export default ChannelInChannelList
